import "@/styles/base.scss";
import React, { FC } from "react";
import { Outlet } from "react-router-dom";
import { AuthProvider } from "@/store/AuthProvider";
import { AgglomerationsProvider } from "@/store/AgglomerationsProvider";
import { PriceRangesProvider } from "@/store/PriceRangesProvider";
import { UserProvider } from "@/store/UserProvider";
import LoaderWrapper from "@/components/LoaderWrapper/LoaderWrapper";
import { useVersionCheck } from "@/utils/hooks/useVersionCheck";
import UserMetadataPoller from "@/components/UserMetadataPoller/UserMetadataPoller";
import { usePromoActivation } from "@/utils/hooks/usePromoActivation";
import PromoGiftModal from "@/components/WelcomeModal/PromoGiftModal";
import PromoCodeModal from "@/components/PromoCodeModal/PromoCodeModal";
import AuthRequired from "@/components/AuthRequired/AuthRequired";
import cls from "./styles.module.scss";

export const App: FC = () => {
  usePromoActivation();
  useVersionCheck();

  return (
    <AuthProvider>
      <AuthRequired>
        <UserProvider>
          <AgglomerationsProvider>
            <PriceRangesProvider>
              <UserMetadataPoller />
              <LoaderWrapper>
                <div className={cls.wrapper}>
                  <div className={cls.container}>
                    <PromoGiftModal />
                    <PromoCodeModal />
                    <Outlet />
                  </div>
                </div>
              </LoaderWrapper>
            </PriceRangesProvider>
          </AgglomerationsProvider>
        </UserProvider>
      </AuthRequired>
    </AuthProvider>
  );
};
